import React, { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import { constants, sortingOptions1 } from "../constant/constants";
import SideMenu from "../component/menu/SideMenu";
import CategoryItemComponent from "../component/CategoryItemComponent";
import { ConfigProvider, notification, Pagination } from "antd";
import AddOrEditCategoryModalV2 from "../component/modals/AddOrEditCategoryModalV2";
import ConfirmationModal from "../component/modals/ConfirmationModal";
import ApiService from "../utils/ApiService";
import useUserStore from "../stores/store";
import { Spin } from "antd";
import DataNotFound from "../component/common/DataNotFound";
import CustomLoader from "../component/menu/CustomLoader";
import TableHeaderComponent from "../component/TableHeaderComponent";

function Category() {
  const { user, restaurantId, restaurantSlug, showNotification } = useUserStore();
  const [api, contextHolder] = notification.useNotification();
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [isCustomModalOpen, setIsCustomModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add"); // 'add' or 'edit'
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [selectedCategory, setSelectedCategory] = useState({});
  const [orders, setOrders] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [firstTime, setFirstTime] = useState(true);
  const [totalCategory, setTotalCategory] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState({
    searchText: "",
    sortBy: "",
    restaurantSlug: "",
    page: currentPage,
    perPage: perPage,
  });
  const [isCategoryLoading, setIsCategoryLoading] = useState(true);
  const [editDependencies, setEditDependencies] = useState([]);
    
  const onSearchText = (value) => {
    setFilter({ ...filter, searchText: value.trim(), page: 1 });
  };

  const onSortRecord = (value) => {
    setFilter({ ...filter, sortBy: value });
  };

  const onClickCancelButton = (value) => {
    setSelectedCategory(value);
    setConfirmationMessage(
      `Are you sure want to cancel category <b>${value.name}</b> submission?`
    );
    setIsConfirmModalOpen(true);
  };

  const onConfirm = (record) => {
    onFinishCategoryStatusChange("Pending", record);
    setIsConfirmModalOpen(false);
  };

  const onNotConfirm = () => {
    setIsConfirmModalOpen(false);
  };

  const filterCategory = () => {
    setIsCategoryLoading(true);
    ApiService.FILTER_CATEGORY_LIST(filter, user.token.token).then((res) => {
      setOrders(
        res?.payload?.categories.map((item) => {
          return {
            id: item._id,
            name: item.name,
            variantCount: item.variantCount,
            isSetMenu: item.isSetMenu,
            catTypeText: item.isSetMenu ? "Set Menu" : "",
            status: item.status,
            image:
              "image" in item
                ? process.env.REACT_APP_APP_BASE_URL + item.image
                : process.env.REACT_APP_APP_BASE_URL + "/images/tabletap.svg",
            restaurantImages: item?.restaurantWiseImages?.map(
              (restaurantImage) => ({
                restaurantId: restaurantImage.restaurantId,
                image: restaurantImage.image,
              })
            ),
          };
        })
      );
      setTotalCategory(res?.payload?.pagination?.total);
      setCurrentPage(res?.payload?.pagination?.page);
      setIsCategoryLoading(false);
    });
  };
  

  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setFilter({ ...filter, page: pageNumber });
  };

  useEffect(() => {
    setFilter({ ...filter, restaurantSlug, sortBy: "NEWEST" });
  }, []);

  useEffect(() => {
    if (!firstTime) {
      filterCategory();
    } else {
      setFirstTime(false);
    }
  }, [filter]);

  const hanldeCategoryConfirmation = (status, record) => {
    if (status !== "Pending") {
      return onFinishCategoryStatusChange(status, record);
    }

    setSelectedCategory(record);
    setConfirmationMessage(
      `Are you sure want to inactive category <b>${record.name}</b>?`
    );
    setIsConfirmModalOpen(true);
  };

  const onFinishAddOrEditCategory = (updatedCategory) => {
    setIsModalOpen(false);
    filterCategory();
  };

  const onFinishCategoryStatusChange = (event, record) => {
    const params = {
      restaurantId: restaurantId,
      categoryId: record.id,
    };

    ApiService.CATEGORY_STATUS_CHANGE(params, user.token.token).then((res) => {
      if (res.code === 200) {
        showNotification("Category status changed", false);

        // Update the category in the state
        setOrders((prevOrders) =>
          prevOrders.map((order) =>
            order.id === record.id
              ? { ...order, status: event } // Update status
              : order
          )
        );
      } else {
        showNotification(res.data.message);
      }
    });
  };

  const handleAddCategory = () => {
    setModalMode("add");
    setSelectedCategory(null); // No category selected in Add mode
    setIsModalOpen(true);
  };

  const handleEditCategory = (category) => {
    setModalMode("edit");
    setSelectedCategory(category); // Pass category to edit
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCategory(null);
  };

  const onFinishCategoryDelete = () => {
    filterCategory();
  }

  return (
    <div className="flex flex-col bg-[#e5e7eb]">
      {contextHolder}
      <CustomLoader />
      <Header title={""} menu={constants.MENU.CATEGORY} currentMenuKey={'T_2_S_2'}/>
      <div className="flex flex-row bg-prewhite">
        <SideMenu
          title={`McDonalds Food Chain`}
          menu={constants.MENU.CATEGORY}
        />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <TableHeaderComponent
              sortingOptions={sortingOptions1}
              onChangeSorting={onSortRecord}
              searchText={searchText}
              setSearchText={setSearchText}
              record={{
                title: "All Category",
                hint: "Search in category",
                callback: handleAddCategory,
                search: onSearchText,
              }}
            />
            <div className="flex flex-col">
              {isCategoryLoading && orders == null ? (
                <div className="h-[70vh] flex items-center justify-center">
                  <Spin size="large" />
                </div>
              ) : orders?.length > 0 ? (
                orders?.map((item, index) => {
                  return (
                    <div key={`cat${index}`}>
                      <CategoryItemComponent
                        record={item}
                        callback={onClickCancelButton}
                        onFinish={hanldeCategoryConfirmation}
                        // onEdit={onClickEditButton} // New prop
                        onEdit={handleEditCategory} // New prop,
                        onFinishCategoryDelete={onFinishCategoryDelete}
                      />
                    </div>
                  );
                })
              ) : (
                <DataNotFound />
              )}
            </div>
            <div className="flex flex-row justify-start font-uregular">
              <ConfigProvider
                theme={{
                  components: {
                    Pagination: {
                      itemActiveBg: "#FFD700",
                      fontFamily: "ubold",
                      colorPrimaryBorder: "#FFD700",
                      colorPrimary: "#111111",
                      colorPrimaryHover: "#111111",
                      itemInputBg: "#111111",
                      itemBg: "#E5E4E9",
                    },
                  },
                }}
              >
                <Pagination
                  total={totalCategory}
                  showTotal={(total) => `Total ${total} items`}
                  defaultPageSize={perPage}
                  defaultCurrent={currentPage}
                  current={currentPage}
                  onChange={onPageChange}
                  showSizeChanger={false}
                />
              </ConfigProvider>
            </div>
          </div>
          <AddOrEditCategoryModalV2
            openModal={isModalOpen}
            onFinish={onFinishAddOrEditCategory}
            onClose={handleCloseModal}
            mode={modalMode} // 'add' or 'edit'
            categoryData={selectedCategory} // Category data for edit mode
            fetchCategoryList={filterCategory}
          />
          <ConfirmationModal
            openModal={isConfirmModalOpen}
            records={{
              onFinish: onConfirm,
              onCancel: onNotConfirm,
              message: confirmationMessage,
              param: selectedCategory,
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Category;
